export default "__VITE_ASSET__DGvWiyKV__"